import { render, staticRenderFns } from "./CoffeeList.vue?vue&type=template&id=7a238941&scoped=true"
import script from "./CoffeeList.vue?vue&type=script&lang=js"
export * from "./CoffeeList.vue?vue&type=script&lang=js"
import style0 from "./CoffeeList.vue?vue&type=style&index=0&id=7a238941&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a238941",
  null
  
)

export default component.exports